import { createFileRoute } from '@tanstack/react-router';
import { DesktopLocations } from '@/features/warehouse/DesktopLocations';

/** Gli scaffali dentro un magazzino. */
export const Route = createFileRoute('/_app/warehouse/locations')({ component: DesktopLocations });
